<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/n8AbiW/images/cover.jpg?1684514755771" alt="This image is the cover for the book Nightmare in Niceville"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nightmare in Niceville
      </h1>
      <p class="bookDescription body article font2">
        <p>Lily Strykes is a typical teenage girl, who, along with her mother and younger sister, settles into a comfortably predictable lifestyle in the quiet little town of Niceville, Florida. But hidden in their past is something dark. A fun night out with friends takes an unexpected and terrifying turn as her previous life quickly catches up to her. Lily's routine but peaceful existence, as well as those of her family and friends, is turned upside down in a matter of hours when a figure from her violent past suddenly returns.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amberle Cianne
      </h2>
      
      <p class="authorDescription body article">At the age of fourteen, Amberle Cianne discovered she wanted to be a writer because it allowed her to express herself and create something real and tangible from her imagination. "Nightmare in Niceville" began as a school project until Amberle's imagination gave it a life of its own. Amberle was born in Tennessee and her family relocated to north Georgia when she was seven. She credits her incredible family and friends for giving her unending support and encouragement for doing what she loves.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BQB Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d94f951